"use client";

import Link from "next/link";
import { Separator } from "@tillix/ui-atoms/separator";
import { Smartphone } from "lucide-react";
import { useWglT } from "./i18n/use-t";

export function WglFooter() {
  const t = useWglT();
  return (
    <footer className="w-full border-t border-t-border bg-primary">
      <div className="mx-auto flex max-w-6xl items-start justify-between gap-8 px-8 py-8 text-primary-foreground text-sm max-md:flex-col">
        <p className="max-w-md text-base">
          <span className="font-bold">{t("footer.taglineLead")}</span>{" "}
          {t("footer.taglineBeforeLink")}{" "}
          <span className="inline-flex">
            <Link
              className="inline-flex items-baseline"
              href="https://go.washingtongas.com/MyWashingtonGas"
              rel="noopener noreferrer"
              target="_blank"
            >
              <Smartphone className="size-4" /> {t("footer.taglineLink")}
            </Link>
          </span>{" "}
          {t("footer.taglineAfterLink")}
        </p>
        <div className="flex flex-col items-start gap-4 max-md:w-full md:items-end md:text-right">
          <div className="max-md:w-full max-md:text-center">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </div>
          <div className="flex flex-col max-md:w-full max-md:gap-2">
            <div className="flex w-full items-center justify-center gap-4 md:justify-end md:gap-2">
              {/* <div className="text-xs opacity-60">powered by tilliX</div> */}
              <Link
                className="underline"
                href="https://www.washingtongas.com/privacy"
              >
                {t("footer.privacyPolicy")}
              </Link>
              <Separator
                className="data-[orientation=vertical]:h-3"
                orientation="vertical"
              />
              <Link
                className="underline"
                href="https://www.washingtongas.com/security-policy"
              >
                {t("footer.securityPolicy")}
              </Link>
              <Separator
                className="data-[orientation=vertical]:h-3"
                orientation="vertical"
              />
              <Link
                className="underline"
                href="https://www.washingtongas.com/terms"
              >
                {t("footer.termsOfUse")}
              </Link>
            </div>
            <div className="flex w-full items-center justify-center gap-4 md:justify-end md:gap-2">
              <Link className="underline" href="https://apple.co/3ug53Ey">
                {t("footer.iosApp")}
              </Link>
              <Separator
                className="data-[orientation=vertical]:h-3"
                orientation="vertical"
              />
              <Link
                className="underline"
                href="https://play.google.com/store/apps/details?id=com.sew.wgl"
              >
                {t("footer.androidApp")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default WglFooter;
